<div class="ic-list {{class}}" data-testId="container">
    <div class="ic-list-header" data-testId="header">
        <ng-content select="[header]"></ng-content>
    </div>

    <div class="ic-list-body" data-testId="body">
        <ng-content select="[body]"></ng-content>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/list/list.component.html